export default __webpack_public_path__ + "static/media/icon-cross-black.9d78b7bd.svg";